<template>
    <multiselect
        v-model="selectedPrepare"
        id="ajax"
        label="name"
        track-by="id"
        placeholder="Начните вводить ИНН или наименование..."
        open-direction="bottom"
        :options="options"
        :multiple="false"
        :searchable="true"
        :loading="loading"
        :internal-search="false"
        :clear-on-select="false"
        :close-on-select="true"
        :hide-selected="false"
        :select-label="'Выбрать'"
        :selected-label="'Выбран'"
        :deselect-label="'Отменить'"
        :limit-text="limitText"
        :max-height="600"
        :show-no-results="true"
        :disabled="disabled"
        @search-change="asyncFind"
        :required="required"
    >
        <template
            slot="option"
            slot-scope="{ option }">
            <span class="custom__tag">
                <span>
                    {{ '#' + option.id + ' ' + option.name + '(' + option.inn + ')' }}
                    <b-badge 
                        v-if="option.status"
                        :variant="option.reference_company_status_id == 370 ? 'danger':'secondary'"
                        class="always-small-badge ml-2"
                        title="Статус выставлен менеджером"
                    >
                        {{ option.status.name }}
                    </b-badge>
                    <template v-if="option.latest_dadata_check && option.latest_dadata_check.is_liquidated">
                        <b-badge 
                            variant="danger" 
                            class="always-small-badge ml-2"
                            title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                        >
                            Авто проверка: Ликвидирована
                        </b-badge>
                    </template>  
                    <template v-if="String(option.inn).length < 10">
                        <b-badge 
                            variant="danger" 
                            class="always-small-badge"
                            title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                        >
                            Ошибка ИНН
                        </b-badge>
                    </template>          
                </span>
            </span>
        </template>
        <span slot="noResult">Такой компании не найдено. Попробуйте изменить параметры поиска или заведите новую компанию.</span>
        <span slot="noOptions">Список пуст. Введите что-нибудь.</span>
    </multiselect>
</template>
<script>
    import {
        API_COMPANY_SEARCH
    } from '../../constants'
    import debounce from '../../services/helpers'

    export default {
        props: {
            defaultSelectName: {
                type: String,
                required: false,
                default: 'Выберите компанию'
            },
            selected: { type: String|Number, required: false },          // What to output in default select
            selectedCompany: { type: Object, required: false },          // What to output in default select
            hotUpdate: { type: Boolean, required: false },               // If we want to update selectedPrepare
            excludeArray: { type: Array,
                required: false,
                default: function () {
                    return []
                }
            },      // If you want to exclude some companies
            disabled: { type: Boolean, default: false },
            required: { type: Boolean, default: false },
            additionalGetParams: { type: String, default: '' },          // Start from &, example: &only=transport
        },
        data() {
            return {
                options: [],
                selectedLocal: '',
                selectedPrepare: {},
                search: '',
                loading: false
            }
        },
        watch: {
            selectedPrepare(element) {
                this.selectedLocal = element == null ? '' : element.id
                this.$emit('set', this.selectedLocal, element)
            },
            hotUpdate(value) {
                if (this.selectedCompany && this.selectedCompany.id) {
                    this.options.push(this.selectedCompany)
                    this.selectedPrepare = this.selectedCompany
                }
            }
        },
        mounted() {
            if (this.selectedCompany && this.selectedCompany.id) {
                this.options.push(this.selectedCompany)
                this.selectedPrepare = this.selectedCompany
            }
        },
        methods: {
            getDataHandler: async function() {
                const response = await api.call('get', API_COMPANY_SEARCH + `?s=${this.search}${this.additionalGetParams}`)
                let resultArray = []
                if (this.excludeArray.length > 0) {
                    response.data.forEach((option, index) => {
                        if (!this.excludeArray.includes(option.id)) {
                            resultArray.push(option)
                        }
                    })
                } else {
                    resultArray = response.data
                }

                this.options = resultArray
                this.prepareSelectedLocal()
                this.loading = false
            },
            asyncFind: debounce(function (searchQuery) {
                this.loading = true
                this.search = searchQuery
                this.getDataHandler()
            }, 500),
            prepareSelectedLocal() {
                this.options.forEach((element) => {
                    if (this.selected == element.id) {
                        this.selectedPrepare = element
                    }
                })
            },
            limitText (count) {
                return `и ${count} других компаний`
            }
        }
    }
</script>
